import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TextBlock } from "../models/text-block";

@Injectable({
  providedIn: "root",
})
export class PublicTextBlockService {
  private baseUrl = "api/public/textblocks";

  constructor(private http: HttpClient) {}

  getBlock(blockCode: string) {
    return this.http.get<TextBlock>(`${this.baseUrl}/${blockCode}`);
  }
}
